import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Ll8xNTVrOWZhMCB7CiAgZGlzcGxheTogbm9uZTsKfQ';
import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Ll8xNTVrOWZhMSB7CiAgZGlzcGxheTogaW5saW5lLWJsb2NrOwogIGN1cnNvcjogcG9pbnRlcjsKfQ';
import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Ll8xNTVrOWZhMSA-IGJ1dHRvbiB7CiAgcG9pbnRlci1ldmVudHM6IG5vbmU7Cn0';
export var input = '_155k9fa0';
export var label = '_155k9fa1';